import React from "react";
import PT from "prop-types";
import styles from "./ExpenseInput.module.scss";
import Input from "../Input";
import { MdClear } from "react-icons/md";

const ExpectedExpense = ({
  onDelete, id, year = '', expense, onChange, minYear, maxYear
}) => {
  return (
      <div className={styles.expected_expense}>
        <span>In</span>
        <div className={styles.rangerPanel}>
          <span>year {year}</span>
          <Input
            onChange={e => onChange(id, e.target.value, expense)}
            value={year}
            type="range"
            style={{ width: '100%' }}
            minstep={1}
            min={minYear}
            max={maxYear}
            placeholder="Year"
          />
        </div>
        <Input
          onChange={e => onChange(id, year, e.target.value)}
          value={expense}
          placeholder="Expense"
        />
        {' '}
        <span className={styles.clear_span} role="presentation" onClick={() => onDelete(id)}>
          <MdClear />
        </span>
    </div>
  );
}

ExpectedExpense.propTypes = {
  onDelete: PT.func.isRequired,
  id: PT.string.isRequired,
  year: PT.oneOfType([PT.string, PT.number]).isRequired,
  expense: PT.oneOfType([PT.string, PT.number]).isRequired,
  onChange: PT.func.isRequired,
};

export default ExpectedExpense;
